import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Which sidebar badge bucket to re-fetch. Use after local mutations so counts stay in sync
 * without waiting for the periodic refresh or SignalR.
 */
export type SidebarBadgeScope = 'launch' | 'clients' | 'vessels' | 'contracts' | 'billing' | 'all';

@Injectable({ providedIn: 'root' })
export class SidebarBadgeRefreshService {
  private readonly changes = new Subject<SidebarBadgeScope>();

  /** Subscribe in the portal sidebar to run scoped API refreshes for nav badges. */
  readonly onChange$: Observable<SidebarBadgeScope> = this.changes.asObservable();

  /** Call from feature code after add / update / delete (or other badge-affecting actions). */
  requestRefresh(scope: SidebarBadgeScope = 'all'): void {
    this.changes.next(scope);
  }
}
